// @flow
import type { BoardSortOptionsType } from 'app/packages/pinterest-flow-types/user';

export type UpdateProfileBoardView = {
  type: 'UPDATE_PROFILE_BOARD_VIEW',
  payload: {
    profileBoardView: ?('square' | 'list' | 'wide'),
  },
};

export function updateProfileBoardView(
  profileBoardView: ?('square' | 'list' | 'wide'),
): UpdateProfileBoardView {
  return {
    type: 'UPDATE_PROFILE_BOARD_VIEW',
    payload: {
      profileBoardView,
    },
  };
}

export type UpdateBoardSortOption = {
  type: 'UPDATE_BOARD_SORT_OPTION',
  payload: {
    updatedBoardOrder: BoardSortOptionsType,
  },
};

export function updateBoardSortOption(
  updatedBoardOrder: BoardSortOptionsType,
): UpdateBoardSortOption {
  return {
    type: 'UPDATE_BOARD_SORT_OPTION',
    payload: {
      updatedBoardOrder,
    },
  };
}

export type UpdateBoardPinDensity = {
  type: 'UPDATE_BOARD_PIN_VIEW',
  payload: {
    boardPinView: '' | 'regular' | 'dense',
  },
};

export function updateBoardPinDensity(boardPinView: 'regular' | 'dense'): UpdateBoardPinDensity {
  return {
    type: 'UPDATE_BOARD_PIN_VIEW',
    payload: {
      boardPinView,
    },
  };
}

export type UpdateProfilePinDensity = {
  type: 'UPDATE_PROFILE_PIN_VIEW',
  payload: {
    profilePinView: '' | 'regular' | 'dense',
  },
};

export function updateProfilePinDensity(
  profilePinView: 'regular' | 'dense',
): UpdateProfilePinDensity {
  return {
    type: 'UPDATE_PROFILE_PIN_VIEW',
    payload: {
      profilePinView,
    },
  };
}
